import LayoutVersionManagerFilters from "./filters";
import LayoutVersionManagerFiltersItem from "./filtersItem";
import LayoutVersionManagerFiltersRoot from "./root";

export const VersionManagerFiltersLayout = {
  Root: LayoutVersionManagerFiltersRoot,
  Filters: LayoutVersionManagerFilters,
  FiltersItem: LayoutVersionManagerFiltersItem,
};
